import { useEffect, useRef, useState, useCallback } from 'react';

const WARNING_TIMEOUT = 25 * 60 * 1000; // 25 minutes
const LOGOUT_TIMEOUT  = 30 * 60 * 1000; // 30 minutes

export const useInactivityTimeout = (onLogout: () => void) => {
  const [showWarning, setShowWarning] = useState(false);
  const warningTimerRef = useRef<NodeJS.Timeout | null>(null);
  const logoutTimerRef  = useRef<NodeJS.Timeout | null>(null);

  const clearTimers = () => {
    if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
    if (logoutTimerRef.current)  clearTimeout(logoutTimerRef.current);
  };

  const resetTimers = useCallback(() => {
    clearTimers();
    setShowWarning(false);

    warningTimerRef.current = setTimeout(() => {
      setShowWarning(true);
    }, WARNING_TIMEOUT);

    logoutTimerRef.current = setTimeout(() => {
      onLogout();
    }, LOGOUT_TIMEOUT);
  }, [onLogout]);

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll'];
    events.forEach(e => window.addEventListener(e, resetTimers));
    resetTimers(); // start timers on mount

    return () => {
      clearTimers();
      events.forEach(e => window.removeEventListener(e, resetTimers));
    };
  }, [resetTimers]);

  return { showWarning, resetTimers };
};